import { render } from "./ProjectCard.vue?vue&type=template&id=7ba06f2d&scoped=true"
import script from "./ProjectCard.vue?vue&type=script&lang=js"
export * from "./ProjectCard.vue?vue&type=script&lang=js"

import "./ProjectCard.vue?vue&type=style&index=0&id=7ba06f2d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ba06f2d"]])

export default __exports__